import { render, staticRenderFns } from "./PhdProposal.vue?vue&type=template&id=1728ef97&"
import script from "./PhdProposal.vue?vue&type=script&lang=js&"
export * from "./PhdProposal.vue?vue&type=script&lang=js&"
import style0 from "./PhdProposal.vue?vue&type=style&index=0&id=1728ef97&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports